import { render } from "./snackbarInitail.vue?vue&type=template&id=c9e38c5e"
import script from "./snackbarInitail.vue?vue&type=script&lang=js"
export * from "./snackbarInitail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/basil/Documents/rishad/ncp_form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__